import React from "react";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { useSelector } from "react-redux";
import { webClientId as defaultKey } from "../config/ClientIds";

const GoogleAuthProviderWrapper = ({ children }) => {
    const settingsdata = useSelector((state) => state.settingsdata);
    const settings = settingsdata.settings;
    
    // Check both potential paths (google.webClientId matches our new Admin UI save path)
    const keyFromSettings = settings?.google?.webClientId || settings?.googleWebClientId;
    const activeKey = keyFromSettings || defaultKey;

    if (!activeKey) {
        return <>{children}</>;
    }

    return (
        <GoogleOAuthProvider clientId={activeKey}>
            {children}
        </GoogleOAuthProvider>
    );
};

export default GoogleAuthProviderWrapper;
